import { ReactNode } from 'react';

interface AppBarProps {
  children: ReactNode;
}

export default function AppBar({ children }: AppBarProps): JSX.Element {
  return (
    <>
      <div className="app-bar" data-elevation="0">
        {children}
      </div>
      <style jsx>{`
        .app-bar {
          width: 100%;
          display: flex;
          flex-direction: column;
          box-sizing: border-box;
          background-color: #fff;
          position: sticky;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1;
        }

        .app-bar[data-elevation='1'] {
          box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14),
            0px 1px 3px 0px rgba(0, 0, 0, 0.12);
        }

        .app-bar[data-elevation='2'] {
          box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14),
            0px 1px 5px 0px rgba(0, 0, 0, 0.12);
        }

        /* Add more elevation levels as needed */
      `}</style>
    </>
  );
}
